import { myServiceDuringMovingDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getmyServiceDuringMovingEn = () => {
  const data = myServiceDuringMovingDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addmyServiceDuringMoving = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/im-moving-what-do-i-need-to-do-with-my-service`,
    ) &&
    document.getElementById(`myServiceDuringMovingJSONLD`) === null
  ) {
    const script = myServiceDuringMovingJSONLDEn()
    addJSONLDToHead(script, `myServiceDuringMovingJSONLD`)
  } else {
    removeElement(`myServiceDuringMovingJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const myServiceDuringMovingJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getmyServiceDuringMovingEn(),
  }
  return FaqBagsterTemplate
}
